/**
 * Wishlist page — render localStorage items, remove, add to cart.
 */
(() => {
  function money(cents) {
    const value = Number(cents) / 100;
    if (Number.isNaN(value)) return '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      }).format(value);
    } catch (_) {
      return `$${value.toFixed(2)}`;
    }
  }

  function cardHtml(item) {
    const title = item.title || item.handle;
    const url = item.url || `/products/${item.handle}`;
    const img = item.image
      ? `<img src="${item.image}" alt="" width="400" height="400" loading="lazy">`
      : '';
    const price = `<p class="oc-wishlist-card__price">${item.price ? money(item.price) : '&nbsp;'}</p>`;

    return `
      <article class="oc-wishlist-card" data-product-id="${item.productId}" data-variant-id="${item.variantId || ''}">
        <a class="oc-wishlist-card__media" href="${url}">${img}</a>
        <h2 class="oc-wishlist-card__title"><a href="${url}">${title}</a></h2>
        ${price}
        <div class="oc-wishlist-card__actions">
          <button type="button" class="oc-wishlist-card__btn" data-wishlist-add-cart>Add to cart</button>
          <button type="button" class="oc-wishlist-card__remove" data-wishlist-remove aria-label="Remove">×</button>
        </div>
      </article>
    `;
  }

  async function addToCart(variantId) {
    if (!variantId) return;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    document.dispatchEvent(new CustomEvent('cart:update'));
    window.location.href = '/cart';
  }

  function render(root) {
    if (!window.OCWishlist) return;
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const items = window.OCWishlist.read();

    if (!grid) return;

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(cardHtml).join('');
  }

  function bind(root) {
    root.addEventListener('click', async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const card = target.closest('.oc-wishlist-card');
      if (!card) return;

      const productId = card.getAttribute('data-product-id');
      const variantId = card.getAttribute('data-variant-id');

      if (target.closest('[data-wishlist-remove]')) {
        window.OCWishlist.remove(productId, variantId || null);
        render(root);
        return;
      }

      if (target.closest('[data-wishlist-add-cart]')) {
        try {
          await addToCart(variantId);
        } catch (_) {
          window.location.href = card.querySelector('a')?.href || '/cart';
        }
      }
    });

    document.addEventListener(window.OCWishlist.CHANGE, () => render(root));
    render(root);
  }

  function init() {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root || !window.OCWishlist) return;
    bind(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
